const KEY = /^[A-Za-z0-9]{10,64}$/;
const KINDS = new Set(['board', 'file', 'design']);

/** A Figma file or branch key (the Worker refuses anything else, never a URL). */
export function isFigmaFileKey(key: string): boolean {
  return KEY.test(key);
}

/**
 * The file key of a pasted FigJam or Figma link (P11b): `https://(www.)figma.com/{board|file|design}/<key>/…`, or the
 * branch key of `…/<key>/branch/<branchKey>/…` (the REST API reads a branch by its own key). Null for anything else.
 */
export function parseFigmaUrl(input: string): { fileKey: string } | null {
  let u: URL;
  try {
    u = new URL(input.trim());
  } catch {
    return null;
  }
  if (u.protocol !== 'https:' || u.username || u.password || (u.hostname !== 'figma.com' && u.hostname !== 'www.figma.com')) return null;
  const [kind, key, sub, branch] = u.pathname.split('/').filter(Boolean);
  if (!kind || !KINDS.has(kind) || !key || !isFigmaFileKey(key)) return null;
  if (sub === 'branch') return branch && isFigmaFileKey(branch) ? { fileKey: branch } : null;
  return { fileKey: key };
}
